// extracted by mini-css-extract-plugin
export default {"tagsContainer":"aroQyt","alignCenter":"broQyt","external":"croQyt","tag":"droQyt","scroll":"eroQyt","column":"froQyt"};